import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Button, Form, Modal, Table, Spinner, Accordion, InputGroup } from 'react-bootstrap';
import { useRef } from 'react';
import ReactToPrint from "react-to-print";
import $ from 'jquery';
import 'jquery-confirm';
import { AppContext } from '../App';
export const Token = () => {
	const { user, tokens, setTokens, tokenServices, payModes, tokenCustomers, dayClose, payWallet, postCall,
		account, getTokenCustomers, setStateSettle, setStateSettleAll } = useContext(AppContext);
	const [tokenModel, setTokenModel] = useState(false);
	const [manageTokenState, setManageTokenState] = useState('add_service');
	const [paymentWallet, setPaymentWallet] = useState({});
	useEffect(() => {
		if (!tokenModel) {
			setLiveToken();
			setSelectedServiceItem();
			setManageTokenState('add_service');
			setRecService({});
			setBillAmount({});
			setTotalCashEntry();
			setPaymentWallet({});
			setWalletEntry();
			setWallBalance();
			setEditToken(false);
		}
	}, [tokenModel]);
	const [openTokenLoad, setOpenTokenLoad] = useState(false);
	const [liveToken, setLiveToken] = useState();
	const [subTotal, setSubTotal] = useState(0);
	const [recStatus, setRecStatus] = useState(false);
	const checkRecStatus = () => {
		let p = new Promise((resolve, reject) => {
			if (liveToken !== undefined) {
				if (Object.keys(liveToken.details.service).length > 0) {
					Object.keys(liveToken.details.service).map(servi => {
						if (liveToken.details.service[servi].reccurent) {
							resolve();
						}
					});
				}
			}
			reject();
		});
		p.then((res) => {
			setRecStatus(true);
		}).catch((err) => {
			setRecStatus(false);
		});
	}
	useEffect(() => {
		if (liveToken !== undefined) {
			setSubTotal(prev => (0));
			Object.keys(liveToken.details.service).map(item => {
				setSubTotal(prev => (
					prev + (parseInt(liveToken.details.service[item].gov_service_charge) + parseInt(liveToken.details.service[item].akshaya_charge)) * parseInt(liveToken.details.service[item].quantity)
				));
			});
			checkRecStatus();
		}
	}, [liveToken]);
	const openToken = (tok) => {
		setLiveToken({ id: tok, details: tokens[tok] });
		setOpenTokenLoad(true);
		setTokenModel(true);
		setManageTokenState('add_service');
		postCall('api/mt/open/token/', { token_id: tok.substring(1) }).then((response) => {
			setTokens(response.data.tokens);
			setStateSettle(response.data.settle);
			setStateSettleAll(response.data.settle_all);
			setLiveToken({ id: tok, details: response.data.tokens[tok] });
			setOpenTokenLoad(false);
		}).catch((err) => {
			setOpenTokenLoad(false);
		});
	}
	const [serviceSearchResult, setServiceSearchResult] = useState({});
	const [serviceSelectCount, setServiceSelectCount] = useState(-1);
	const [selectedServiceItem, setSelectedServiceItem] = useState();
	useEffect(() => {
		if (selectedServiceItem !== undefined) {
			$('#serv_search').val(selectedServiceItem.service.name);
			$('#service_qty').focus();
		}
	}, [selectedServiceItem]);
	$('#service_qty').off().on("keydown", function (e) {
		let code = e.which || e.keyCode;
		if (code === 13) {
			e.preventDefault();
			$('#add_item').focus();
		}
	});
	const [showAutoSuggestion, setShowAutoSuggestion] = useState(false);
	const serviceSearch = (search_key) => {
		setServiceSearchResult(prev => ({}));
		if (search_key !== "") {
			if (tokenServices !== undefined) {
				setSelectedServiceItem();
				if (Object.keys(tokenServices).length > 0) {
					setServiceSelectCount(-1);
					setShowAutoSuggestion(true);
					let count = 0;
					Object.keys(tokenServices).map(service => {
						if (count < 50) {
							if (tokenServices[service].name.toLowerCase().includes(search_key.toLowerCase())) {
								setServiceSearchResult(prev => ({ ...prev, [service]: tokenServices[service] }));
								count += 1;
							}
						}
					});
				}
			}
		} else {
			setServiceSearchResult(prev => ({}));
		}
	}
	$('#serv_search').off().on("keydown", function (e) {
		var code = e.which || e.keyCode;
		if (code === 40) {
			e.preventDefault();
			if (serviceSelectCount < Object.keys(serviceSearchResult).length - 1) {
				setServiceSelectCount(prev => prev + 1);
			} else {
				setServiceSelectCount(0);
			}
		} else if (code === 38) {
			e.preventDefault();
			if (serviceSelectCount > 0) {
				setServiceSelectCount(prev => prev - 1);
			} else {
				setServiceSelectCount(Object.keys(serviceSearchResult).length - 1);
			}
		} else if (code === 13) {
			e.preventDefault();
			setShowAutoSuggestion(false);
			if (serviceSelectCount >= 0) {
				setSelectedServiceItem({ id: Object.keys(serviceSearchResult)[serviceSelectCount], service: serviceSearchResult[Object.keys(serviceSearchResult)[serviceSelectCount]] });
			}
		}
	});
	const [addServiceToTokenLoad, setAddServiceToTokenLoad] = useState(false);
	const serviceAdd = (e) => {
		e.preventDefault();
		if (liveToken !== undefined && selectedServiceItem !== undefined) {
			setAddServiceToTokenLoad(true);
			postCall('api/mt/add/service/token/', {
				token_id: liveToken.id.substring(1),
				service_id: selectedServiceItem.id.substring(1),
				quantity: e.target.qty.value,
			}).then((response) => {
				setAddServiceToTokenLoad(false);
				setTokens(response.data.tokens);
				setStateSettle(response.data.settle);
				setStateSettleAll(response.data.settle_all);
				setLiveToken({ id: liveToken.id, details: response.data.tokens[liveToken.id] });
				$('#serv_search').val('');
				$('#serv_search').focus();
				setSelectedServiceItem();
				setServiceSelectCount(-1);
			}).catch((err) => {
				setAddServiceToTokenLoad(false);
			});
		}
	}
	const [serviceEdit, setServiceEdit] = useState(false);
	const [serviceEditLoad, setServiceEditLoad] = useState(false);
	const [editServiceItem, setEditServiceItem] = useState();
	const updateServiceQty = (e) => {
		e.preventDefault();
		let qty = e.target.qty.value;
		if (qty !== "" && qty > 0) {
			setServiceEditLoad(true);
			postCall('api/mt/edit/service/token/', {
				token_id: liveToken.id.substring(1),
				tokenservice_id: editServiceItem.id.substring(1),
				quantity: qty,
			}).then((response) => {
				setServiceEditLoad(false);
				setTokens(response.data.tokens);
				setStateSettle(response.data.settle);
				setStateSettleAll(response.data.settle_all);
				setLiveToken({ id: liveToken.id, details: response.data.tokens[liveToken.id] });
				setServiceEdit(false);
				setEditServiceItem();
			}).catch((err) => {
				setServiceEditLoad(false);
			});
		}
	}
	const [deleteServiceId, setDeleteServiceId] = useState()
	const [serviceDeleteLoad, setServiceDeleteLoad] = useState(false);
	const deleteTokenService = (did) => {
		if (liveToken !== undefined && did !== "") {
			setServiceDeleteLoad(true);
			postCall('api/mt/delete/service/token/', {
				token_id: liveToken.id.substring(1),
				tokenservice_id: did.substring(1),
			}).then((response) => {
				setServiceDeleteLoad(false);
				setTokens(response.data.tokens);
				setStateSettle(response.data.settle);
				setStateSettleAll(response.data.settle_all);
				setLiveToken({ id: liveToken.id, details: response.data.tokens[liveToken.id] });
				setDeleteServiceId();
			}).catch((err) => {
				setServiceDeleteLoad(false);
			});
		}
	}
	const [cancelTokenLoad, setCancelTokenLoad] = useState(false);
	const [reasonREqErr, setReasonReqErr] = useState(false);
	const cancelToken = (e) => {
		e.preventDefault();
		let reason = e.target.reason.value;
		if (reason === "") {
			setReasonReqErr(true);
			setTimeout(() => { setReasonReqErr(false) }, 5000);
		}
		if (liveToken !== undefined && reason !== "") {
			setCancelTokenLoad(true);
			postCall('api/mt/cancel/token/', {
				token_id: liveToken.id.substring(1),
				reason: reason,
			}).then((response) => {
				setCancelTokenLoad(false);
				setTokens(response.data.tokens);
				setStateSettle(response.data.settle);
				setStateSettleAll(response.data.settle_all);
				setTokenModel(false);
			}).catch((err) => {
				setCancelTokenLoad(false);
			});
		}
	}

	const [nRecId, setNrecId] = useState();
	const [recAutoSuggest, setRecAutoSuggest] = useState(false);
	const [customerSearchResult, setCustomerSearchResult] = useState();
	const [cusSelectCount, setCusSelectCount] = useState(-1);
	const searchCustomer = (c_num, recid) => {
		setCustomerSearchResult(prev => { });
		if (c_num !== "") {
			if (tokenCustomers !== undefined) {
				if (recid !== undefined) {
					$(`#name${recid}`).val('');
					$(`#address${recid}`).val('');
					if (recService[recid] !== undefined) {
						setRecService(prev => ({ ...prev, [recid]: { ...prev[recid], notify: { ...prev[recid].notify, name: "" } } }));
						setRecService(prev => ({ ...prev, [recid]: { ...prev[recid], notify: { ...prev[recid].notify, address: "" } } }));
						setRecService(prev => ({ ...prev, [recid]: { ...prev[recid], notify: { ...prev[recid].notify, customer_id: "" } } }));
					}
				}
				if (Object.keys(tokenCustomers).length > 0) {
					setCusSelectCount(-1);
					setRecAutoSuggest(true);
					let count = 0;
					Object.keys(tokenCustomers).map(customer => {
						if (count < 20) {
							if (tokenCustomers[customer].phone.includes(c_num)) {
								setCustomerSearchResult(prev => ({ ...prev, [customer]: tokenCustomers[customer] }));
								count += 1;
							}
						}
					});
				}
			}
		} else {
			setCustomerSearchResult(prev => { });
		}
	}
	$('.cus_phone').off().on("keydown", function (e) {
		var code = e.which || e.keyCode;
		if (customerSearchResult !== undefined && Object.keys(customerSearchResult).length > 0) {
			if (code === 40) {
				e.preventDefault();
				if (cusSelectCount < Object.keys(customerSearchResult).length - 1) {
					setCusSelectCount(prev => prev + 1);
				} else {
					setCusSelectCount(0);
				}
			} else if (code === 38) {
				e.preventDefault();
				if (cusSelectCount > 0) {
					setCusSelectCount(prev => prev - 1);
				} else {
					setCusSelectCount(Object.keys(customerSearchResult).length - 1);
				}
			} else if (code === 13) {
				if (cusSelectCount >= 0) {
					e.preventDefault();
					setRecAutoSuggest(false);
					if (cusSelectCount >= 0) {
						$(`#phone${nRecId}`).val(customerSearchResult[Object.keys(customerSearchResult)[cusSelectCount]].phone);
						$(`#name${nRecId}`).val(customerSearchResult[Object.keys(customerSearchResult)[cusSelectCount]].name);
						$(`#address${nRecId}`).val(customerSearchResult[Object.keys(customerSearchResult)[cusSelectCount]].address);
						setRecService(prev => ({
							...prev, [nRecId]: {
								...prev[nRecId], notify: {
									...prev[nRecId].notify, customer_id: Object.keys(customerSearchResult)[cusSelectCount].substring(1),
								}
							}
						}
						));
						setRecService(prev => ({
							...prev, [nRecId]: {
								...prev[nRecId], notify: {
									...prev[nRecId].notify, phone: tokenCustomers[Object.keys(customerSearchResult)[cusSelectCount]].phone,
								}
							}
						}
						));
						setRecService(prev => ({
							...prev, [nRecId]: {
								...prev[nRecId], notify: {
									...prev[nRecId].notify, name: customerSearchResult[Object.keys(customerSearchResult)[cusSelectCount]].name,
								}
							}
						}
						));
						setRecService(prev => ({
							...prev, [nRecId]: {
								...prev[nRecId], notify: {
									...prev[nRecId].notify, address: customerSearchResult[Object.keys(customerSearchResult)[cusSelectCount]].address,
								}
							}
						}
						));
					}
				}
			}
		}
	});
	const changeNotify = (keyword, recS, parm) => {
		setRecService(prev => ({
			...prev, [recS]: {
				...prev[recS], notify: {
					...prev[recS].notify, [parm]: keyword
				}
			}
		}
		));
		if (parm === 'phone') {
			setNrecId(recS);
			searchCustomer(keyword, recS);
		}
	}
	const [billAmount, setBillAmount] = useState({});
	const [totalCashEntry, setTotalCashEntry] = useState(0);
	useEffect(() => {
		setTotalCashEntry(0);
		if (billAmount !== undefined && Object.keys(billAmount).length > 0) {
			Object.values(billAmount).map(amt => {
				setTotalCashEntry(prev => (parseInt(prev) + parseInt(amt)));
			});
		}
	}, [billAmount]);
	const addBillAmount = (amt, mode) => {
		if (amt !== "") {
			setBillAmount(prev => ({ ...prev, [mode]: amt }));
		} else {
			setBillAmount(prev => ({ ...prev, [mode]: 0 }));
		}
	}
	const [billSettleLoad, setBillSettleLoad] = useState(false);
	const formatRec = () => {
		let ret = [];
		if (recService !== undefined && Object.keys(recService).length > 0) {
			Object.keys(recService).map(recs => {
				ret.push({ id: recs.substring(1), notify: recService[recs].notify });
			});
		}
		return (ret);
	}
	const [editToken, setEditToken] = useState(false);
	const [editTokId, setEditTokId] = useState();
	const settleBill = (ps) => {
		if (subTotal !== undefined && totalCashEntry !== undefined && subTotal === totalCashEntry) {
			setBillSettleLoad(true)
			if (editToken !== undefined && editToken) {
				postCall('api/mt/edit/token/end/', {
					token_id: liveToken.id.substring(1),
					rec_service: formatRec(),
					payment: billAmount,
					wallet: paymentWallet,
				}).then((response) => {
					setTokens(response.data.tokens);
					setStateSettle(response.data.settle);
					setStateSettleAll(response.data.settle_all);
					setBillSettleLoad(false);
					if (!ps) {
						setTokenModel(false);
					}
				}).catch((err) => {
					setBillSettleLoad(false);
				});
			} else {
				postCall('api/mt/close/token/', {
					token_id: liveToken.id.substring(1),
					rec_service: formatRec(),
					payment: billAmount,
					wallet: paymentWallet,
				}).then((response) => {
					setTokens(response.data.tokens);
					setStateSettle(response.data.settle);
					setStateSettleAll(response.data.settle_all);
					setBillSettleLoad(false);
					if (!ps) {
						setTokenModel(false);
					}
				}).catch((err) => {
					setBillSettleLoad(false);
				});
			}
		}
	}
	const [submitTokenLoad, setSubmitTokenLoad] = useState(false);
	const submitToken = () => {
		setSubmitTokenLoad(true)
		postCall('api/mt/submit/token/', {
			token_id: liveToken.id.substring(1),
			rec_service: formatRec(),
			wallet: paymentWallet,
		}).then((response) => {
			setTokens(response.data.tokens);
			setStateSettle(response.data.settle);
			setStateSettleAll(response.data.settle_all);
			setSubmitTokenLoad(false);
			setTokenModel(false);
		}).catch((err) => {
			setSubmitTokenLoad(false);
		});
	}
	const [newTokenModel, setNewTokenModel] = useState(false);
	useEffect(() => {
		if (!newTokenModel) {
			setSelectedService();
			setTokenBookingState('start');
			setServiceSearchResults(prev => { });
		}
	}, [newTokenModel]);
	const [tokenBookingState, setTokenBookingState] = useState('start');
	const [phoneReqErr, setPhoneReqErr] = useState(false);
	const [nameReqErr, setNameReqErr] = useState(false);
	const [qtyReqErr, setQtyReqErr] = useState(false);
	const [selectCount, setSelectCount] = useState(-1);
	const [showAutoSuggestionNew, setShowAutoSuggestionNew] = useState(false);
	const [selectedService, setSelectedService] = useState();
	const [selectedItem, setSelectedItem] = useState();
	useEffect(() => {
		if (selectedItem !== undefined) {
			$('#cus_phone').val(selectedItem.profile.phone);
			$('#cus_name').val(selectedItem.profile.name);
			$('#cus_address').val(selectedItem.profile.address);
		} else {
			$('#cus_name').val('');
			$('#cus_address').val('');
		}
	}, [selectedItem]);
	const [searchResult, setSearchResult] = useState({});
	const searchCustomerNew = (c_num) => {
		setSearchResult(prev => { });
		if (c_num !== "") {
			if (tokenCustomers !== undefined) {
				setSelectedItem();
				if (Object.keys(tokenCustomers).length > 0) {
					setSelectCount(-1);
					setShowAutoSuggestionNew(true);
					let count = 0;
					Object.keys(tokenCustomers).map(customer => {
						if (count < 20) {
							if (tokenCustomers[customer].phone.match(c_num)) {
								setSearchResult(prev => ({ ...prev, [customer]: tokenCustomers[customer] }));
								count += 1;
							}
						}
					});
				}
			}
		} else {
			setSearchResult(prev => { });
		}
	}
	$('#cus_phone').off().on("keydown", function (e) {
		var code = e.which || e.keyCode;
		if (code === 40) {
			e.preventDefault();
			if (selectCount < Object.keys(searchResult).length - 1) {
				setSelectCount(prev => prev + 1);
			} else {
				setSelectCount(0);
			}
		} else if (code === 38) {
			e.preventDefault();
			if (selectCount > 0) {
				setSelectCount(prev => prev - 1);
			} else {
				setSelectCount(Object.keys(searchResult).length - 1);
			}
		} else if (code === 13) {
			e.preventDefault();
			setShowAutoSuggestionNew(false);
			if (selectCount >= 0) {
				setSelectedItem({ id: Object.keys(searchResult)[selectCount], profile: searchResult[Object.keys(searchResult)[selectCount]] });
			}
		}
	});
	const [addTokenLoad, setAddTokenLoad] = useState(false);
	const [tokenAddSuccess, setTokenAddSuccess] = useState(false);
	const [tokenToPrint, setTokenToPrint] = useState();
	const generateToken = (e) => {
		e.preventDefault();
		let phone = e.target.phone.value;
		let name = e.target.name.value;
		let address = e.target.address.value;
		let qty = e.target.qty.value;
		let remarks = e.target.remarks.value;
		let documents = e.target.documents.value;
		if (name === "") {
			setNameReqErr(true);
			setTimeout(() => { setNameReqErr(false) }, 5000);
		}
		if (qty === "") {
			setQtyReqErr(true);
			setTimeout(() => { setQtyReqErr(false) }, 5000);
		}
		if (name !== "" && qty !== "") {
			setAddTokenLoad(true);
			postCall('api/mt/add/token/', {
				customer_id: selectedItem !== undefined ? selectedItem.id.substring(1) : '',
				service_id: selectedService !== undefined ? selectedService.id.substring(1) : '',
				name: name,
				phone: phone,
				address: address,
				quantity: qty,
				remarks: remarks,
				documents: documents,
			}).then((response) => {
				setAddTokenLoad(false);
				setTokens(response.data.tokens);
				setStateSettle(response.data.settle);
				setStateSettleAll(response.data.settle_all);
				// if (response.data.print!==undefined) {
				// 	setTokenBookingState('print');
				// 	setTokenToPrint(response.data.print);
				// }
				setNewTokenModel(false);
				getTokenCustomers();
			}).catch((err) => {
				setAddTokenLoad(false);
			});
		}
	}
	const billRef = useRef();
	const printOldBill = (tok) => {
		setLiveToken({ id: tok, details: tokens[tok] });
		setTokenModel(true);
		setManageTokenState('print');
	}
	const tokenRef = useRef(null);
	const [serviceSearchResults, setServiceSearchResults] = useState(undefined);
	const searchServices = (s_name) => {
		if (s_name !== "") {
			let results = {};
			if (tokenServices !== undefined) {
				if (Object.keys(tokenServices).length > 0) {
					let count = 0;
					Object.keys(tokenServices).map(service => {
						if (count < 20) {
							if (tokenServices[service].name.toLowerCase().includes(s_name.toLowerCase())) {
								results[service] = tokenServices[service];
								count += 1;
							}
						}
					});
				}
			}
			setServiceSearchResults(results);
		} else { setServiceSearchResults(undefined) }
	}
	const [ediTc, setEditTc] = useState();
	const [editTcLoad, setEditTcLoad] = useState(false);
	const updateTc = (e) => {
		e.preventDefault();
		let tc = e.target.tc.value;
		if (tc !== "") {
			setEditTcLoad(true);
			postCall('api/mt/edit/transaction/charge/', {
				token_id: liveToken.id.substring(1),
				tokenservice_id: ediTc.id.substring(1),
				gov_service_charge: tc,
			}).then((response) => {
				setEditTcLoad(false);
				setTokens(response.data.tokens);
				setStateSettle(response.data.settle);
				setStateSettleAll(response.data.settle_all);
				setLiveToken({ id: liveToken.id, details: response.data.tokens[liveToken.id] });
				setEditTc();
			}).catch((err) => {
				setEditTcLoad(false);
			});
		}
	}
	const [ediSc, setEditSc] = useState();
	const [editScLoad, setEditScLoad] = useState(false);
	const updateSc = (e) => {
		e.preventDefault();
		let sc = e.target.sc.value;
		if (sc !== "") {
			setEditScLoad(true);
			postCall('api/mt/edit/service/charge/', {
				token_id: liveToken.id.substring(1),
				tokenservice_id: ediSc.id.substring(1),
				akshaya_charge: sc,
			}).then((response) => {
				setEditScLoad(false);
				setTokens(response.data.tokens);
				setStateSettle(response.data.settle);
				setStateSettleAll(response.data.settle_all);
				setLiveToken({ id: liveToken.id, details: response.data.tokens[liveToken.id] });
				setEditSc();
			}).catch((err) => {
				setEditScLoad(false);
			});
		}
	}
	const [recService, setRecService] = useState({});
	useEffect(() => {
		setCusSelectCount(-1);
	}, [recService]);
	const setReccurent = () => {
		setRecService(prev => ({}));
		if (liveToken !== undefined) {
			if (Object.keys(liveToken.details.service).length > 0) {
				Object.keys(liveToken.details.service).map(servi => {
					if (liveToken.details.service[servi].reccurent) {
						setRecService(prev => ({ ...prev, [servi]: liveToken.details.service[servi] }));
						setRecService(prev => ({
							...prev, [servi]: {
								...prev[servi], notify: {
									...prev[servi].notify, expiry_date: liveToken.details.service[servi].expiry_date
								}
							}
						}
						));
						if (tokenCustomers[`_${liveToken.details.customer_id}`] !== undefined) {
							setRecService(prev => ({
								...prev, [servi]: {
									...prev[servi], notify: {
										...prev[servi].notify, phone: tokenCustomers[`_${liveToken.details.customer_id}`].phone
									}
								}
							}
							));
							setRecService(prev => ({
								...prev, [servi]: {
									...prev[servi], notify: {
										...prev[servi].notify, customer_id: liveToken.details.customer_id
									}
								}
							}
							));
							setRecService(prev => ({
								...prev, [servi]: {
									...prev[servi], notify: {
										...prev[servi].notify, name: tokenCustomers[`_${liveToken.details.customer_id}`].name
									}
								}
							}
							));
							setRecService(prev => ({
								...prev, [servi]: {
									...prev[servi], notify: {
										...prev[servi].notify, address: tokenCustomers[`_${liveToken.details.customer_id}`].address
									}
								}
							}
							));
						}
					}
				});
			}
		}
	}
	const [wallBalance, setWallBalance] = useState();
	const [getWbLoad, setGetWbLoad] = useState(false);
	const [walletEntry, setWalletEntry] = useState();
	const getWalletBalnce = () => {
		setGetWbLoad(true);
		postCall('api/ap/check/wallet/balance/from/token/id/', { t_id: liveToken.id.substring(1) }).then(res => {
			setGetWbLoad(false);
			if (res.data.status) {
				setWallBalance(res.data.balance);
			}
		}).catch(err => {
			setGetWbLoad(false);
		});
	}
	const checkReccurent = () => {
		getWalletBalnce();
		let p = new Promise((resolve, reject) => {
			if (liveToken !== undefined) {
				if (Object.keys(liveToken.details.service).length > 0) {
					Object.keys(liveToken.details.service).map(servi => {
						if (liveToken.details.service[servi].reccurent) {
							resolve();
						}
					});
				}
			}
			reject();
		});
		p.then((res) => {
			setManageTokenState('reccurent_service');
			setReccurent();
		}).catch((err) => {
			setManageTokenState('payment_token');
		});
	}
	const backReccurent = () => {
		let flag = ''
		Object.keys(liveToken.details.service).map((item) => {
			if (parseFloat(liveToken.details.service[item].gov_service_charge) > 0) {
				flag = 'pay-w';
				return;
			}
		});
		if (flag === '') {
			flag = 'add_service';
		}
		setManageTokenState(flag);
	}
	const backPayment = () => {
		let p = new Promise((resolve, reject) => {
			if (liveToken !== undefined) {
				if (Object.keys(liveToken.details.service).length > 0) {
					Object.keys(liveToken.details.service).map(servi => {
						if (liveToken.details.service[servi].reccurent) {
							resolve();
						}
					});
				}
			}
			reject();
		});
		p.then((res) => {
			setManageTokenState('reccurent_service');
		}).catch((err) => {
			backReccurent();
		});
	}
	const addServiceNext = () => {
		if (liveToken === undefined || liveToken === null || liveToken.details === undefined || liveToken.details.service === undefined ||
			Object.keys(liveToken.details.service).length === 0
		) {
			return;
		}
		let flag = '';
		Object.keys(liveToken.details.service).map((item) => {
			if (parseFloat(liveToken.details.service[item].gov_service_charge) > 0) {
				flag = 'pay-w';
				return;
			}
		});
		if (flag === '') {
			Object.keys(liveToken.details.service).map((item) => {
				if (liveToken.details.service[item].reccurent) {
					flag = 'reccurent_service';
					checkReccurent();
					return;
				}
			});
		}
		if (flag === '') {
			getWalletBalnce();
			flag = 'payment_token';
		}
		setManageTokenState(flag);

	}

	return (
		<div className="container-fluid px-0">
			<div className="manage-token-body">
				<div className="token-item-header justify-content-between">
					<span className="f18" >Tokens</span>
					{
						user !== undefined ? (
							user.type === 'admin' ? (
								<Button onClick={() => { setNewTokenModel(true) }} className="btn btn-add-token br-3 d-grid">Add new</Button>
							) : (
								user.permission !== undefined ? (
									user.permission.token.A ? (
										<Button onClick={() => { setNewTokenModel(true) }} className="btn btn-add-token br-3 d-grid">Add new</Button>
									) : ''
								) : ''
							)
						) : ''
					}
				</div>
				<div className="p-2">
					{
						tokens !== undefined && Object.keys(tokens).length > 0 ? (
							Object.keys(tokens).reverse().map((tok, tok_i) => (
								<div className={`token-service-item bdr1 br-3 mb-2 px-2 ${tokens[tok].status}`} key={`tok_${tok_i}`}>
									<div className="item-tid bdr2-r">
										<div className='d-flex align-items-center justify-content-between gap-2'>
											<span className="tp1 f18" >No : {tokens[tok].token_number}</span>
											{
												tokens[tok].status === 'create' ? (
													<Button variant='outline-primary' className='br-2' onClick={() => {
														setTokenBookingState('print');
														setNewTokenModel(true);
														setTokenToPrint({ id: tok, details: tokens[tok] });
													}} size='sm' ><i className="bi bi-printer"></i></Button>
												) : ''
											}
										</div>
										<span className="tp3 f16" >Id : {tok.substring(1)}</span>
										<div className="mt-1">
											{
												tokens[tok].status === 'create' ? <span className="status-badge new"><i className="bi bi-stars"></i> New</span> :
													tokens[tok].status === 'open' ? <span className="status-badge processing"><i className="bi bi-clock-history"></i> Processing</span> :
														tokens[tok].status === 'close' ? <span className="status-badge completed"><i className="bi bi-check-lg"></i> Completed</span> :
															tokens[tok].status === 'cancel' ? <span className="status-badge cancelled">Cancelled</span> : ''
											}
										</div>
									</div>
									<div className="item-tservice bdr2-r">
										{
											tokens[tok].service !== undefined && Object.keys(tokens[tok].service).length > 0 ? (
												<span className="tp1 f18 service-name" >{tokens[tok].service[Object.keys(tokens[tok].service)[0]].name}</span>
											) : <span className="text-muted">No service added</span>
										}
										<div className="customer-info">
											<span className="tp3 f14" >{tokens[tok].customer_name}</span>
											<span className="separator">|</span>
											<span className="tp3 f14" >{tokens[tok].phone}</span>
											<span className="separator">|</span>
											<span className="tp3 f14" >{tokens[tok].time}</span>
										</div>
										<div className="user-action-info mt-1">
											{
												tokens[tok].status === 'create' ? <small className="text-muted">Created by {tokens[tok].created_username}</small> :
													tokens[tok].status === 'open' ? <small className="text-muted">Open by {tokens[tok].username}</small> :
														tokens[tok].status === 'close' ? <small className="text-muted">Closed by {tokens[tok].username}</small> :
															tokens[tok].status === 'cancel' ? (
																<div className="d-flex flex-column">
																	<small className="text-muted">Cancelled by {tokens[tok].username}</small>
																	<small className="text-danger">Reason: {tokens[tok].reason}</small>
																</div>
															) : ''
											}
										</div>
									</div>
									{/* Action Buttons */}
									<div className="item-toption gap-2">
										{/* Open/Edit Button for New & Ongoing Tokens */}
										{
											(tokens[tok].status === 'create' || tokens[tok].status === 'open') ? (
												user !== undefined && (user.type === 'admin' || (user.permission && user.permission.token && (user.permission.token.E || user.permission.token.X))) ? (
													dayClose ? (
														liveToken !== undefined && liveToken.id === tok && openTokenLoad ? (
															<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /></span></Button>
														) : (
															<Button className="br-2 px-3" variant={tokens[tok].status === 'create' ? 'primary' : 'warning'} onClick={() => {
																if (tokens[tok].status === 'create') {
																	openToken(tok);
																} else {
																	setLiveToken({ id: tok, details: tokens[tok] });
																	setTokenModel(true);
																	setManageTokenState('add_service');
																}
															}} >{tokens[tok].status === 'create' ? <><i className="bi bi-stars"></i> Open</> : <><i className="bi bi-pencil-square"></i> Edit</>}
															</Button>
														)
													) : ''
												) : ''
											) : ''
										}
										{/* Reopen Button for Cancelled Tokens */}
										{
											tokens[tok].status === 'cancel' ? (
												user !== undefined && (user.type === 'admin' || (user.permission && user.permission.token && user.permission.token.E)) ? (
													dayClose ? (
														liveToken !== undefined && liveToken.id === tok && openTokenLoad ? (
															<Button className="btn-t1 br-2" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /></span></Button>
														) : (
															<Button className="px-3 br-2" onClick={() => { openToken(tok) }} >Reopen</Button>
														)
													) : ''
												) : ''
											) : ''
										}
										{/* Edit/Print Buttons for Completed Tokens */}
										{
											tokens[tok].status === 'close' ? (
												<>
													{
														editTokId !== undefined && editTokId === tok ? (
															<Button className="btn-t1" size="sm" ><Spinner animation="border" size="sm" /> Wait...</Button>
														) : (
															<Button onClick={() => {
																$.confirm({
																	title: 'Are you sure to edit?',
																	content: 'Edit bill will remove previous settlement!',
																	type: 'orange',
																	buttons: {
																		ok: {
																			text: "Confirm",
																			btnClass: 'btn-primary',
																			keys: ['enter'],
																			action: function () {
																				setEditTokId(tok);
																				postCall('api/mt/edit/token/start/', { tid: tok.substring(1) }).then(res => {
																					setLiveToken({ id: tok, details: tokens[tok] });
																					setTokenModel(true);
																					setManageTokenState('add_service');
																					setEditToken(true);
																					setEditTokId();
																				}).catch(err => {
																					setEditTokId();
																					$.alert({
																						title: 'Alert!',
																						content: 'Something Wrong!',
																					});
																				})
																			}
																		},
																		cancel: function () { }
																	}
																});
															}} className="br-2 px-3" variant='outline-primary' ><i className="bi bi-pencil-square"></i> Edit</Button>
														)
													}
													{
														user !== undefined && user.type === 'admin' ? (
															<Button onClick={() => { printOldBill(tok) }} className="br-2 px-3" variant='outline-secondary' ><i className="bi bi-printer"></i> Print</Button>
														) : ''
													}
												</>
											) : ''
										}
									</div>
								</div>
							))
						) : <div className="p-3 text-center text-muted">No tokens found</div>
					}
				</div>
			</div>
			<Modal size="xl" show={tokenModel} backdrop="static" onHide={() => { setTokenModel(false) }}>
				{
					editToken !== undefined && editToken ? (
						<Modal.Header>
							<Modal.Title>
								<div className="d-grid">
									<span className="tp1 f18 mb-1" >Token No : {liveToken !== undefined ? liveToken.details.token_number : ''}</span>
									{
										liveToken !== undefined ? (
											<span className="tp3 f14" >{liveToken.details.customer_name} / {liveToken.details.phone} / {liveToken.details.time}</span>
										) : ''
									}
								</div>
							</Modal.Title>
						</Modal.Header>
					) : (
						<Modal.Header closeButton>
							<Modal.Title>
								<div className="d-grid">
									<span className="tp1 f18 mb-1" >Token No : {liveToken !== undefined ? liveToken.details.token_number : ''}</span>
									{
										liveToken !== undefined ? (
											<span className="tp3 f14" >{liveToken.details.customer_name} / {liveToken.details.phone} / {liveToken.details.time}</span>
										) : ''
									}
								</div>
							</Modal.Title>
						</Modal.Header>
					)
				}
				<Modal.Body>
					{
						manageTokenState !== undefined ? (
							manageTokenState === 'pay-w' ? (
								liveToken !== undefined && payWallet !== undefined && liveToken.details && liveToken.details.service !== undefined ? (
									Object.keys(liveToken.details.service).length > 0 ? (
										<>
											<span className="tp1 f18 mb-1 p-2 bgs1 bdr2 d-grid br-3 mb-3" >Choose Transaction Charge Debit Wallet</span>
											{
												Object.keys(liveToken.details.service).map((pays, paysi) => (
													parseFloat(liveToken.details.service[pays].gov_service_charge) > 0 ? (
														<div className="grid1by1 align-items-center mb-3" key={`paysi_${paysi}`} >
															<span className='px-2' >{liveToken.details.service[pays].name}</span>
															<Form.Select onChange={(e) => {
																setPaymentWallet(prev => ({ ...prev, [pays]: e.target.value }));
															}} className="shadow-none br-2">
																<option value="">Choose wallet</option>
																{
																	payWallet !== undefined && Object.keys(payWallet).length > 0 ? (
																		Object.keys(payWallet).map((ven, v_i) => (
																			<option value={ven} key={`wall_${v_i}`}>{payWallet[ven].name}</option>
																		))
																	) : ''
																}
															</Form.Select>
														</div>
													) : null
												))
											}
										</>
									) : 'Payment wallet NOT found!'
								) : 'Payment wallet NOT found!'
							) : manageTokenState === 'add_service' ? (
								<>
									{
										user !== undefined ? (
											user.type === 'admin' ? (
												<Row className="mb-2" >
													<Col className="service-search-wrapper mx-2 p-2 br-3" >
														<Form className="service-add-form" onSubmit={serviceAdd} >
															<div className="pos-rel">
																<Form.Control type="text" id="serv_search" onChange={(e) => { serviceSearch(e.target.value) }} autoComplete="off" placeholder="Add new service" />
																{
																	serviceSearchResult !== undefined && showAutoSuggestion ? (
																		Object.keys(serviceSearchResult).length > 0 ? (
																			<div className="customer-search-results bdr1">
																				{
																					Object.keys(serviceSearchResult).map((serv, serv_i) => (
																						<span onClick={() => {
																							setSelectedServiceItem({ id: serv, service: serviceSearchResult[serv] });
																							setShowAutoSuggestion(false);
																						}} className={serv === Object.keys(serviceSearchResult)[serviceSelectCount] ? 'd-grid bdrb1 active' : 'd-grid bdrb1'} key={`servi_${serv_i}`}>{serviceSearchResult[serv].name}</span>
																					))
																				}
																			</div>
																		) : ''
																	) : ''
																}
															</div>
															<Form.Control type="number" name="qty" id="service_qty" defaultValue="1" min="1" placeholder="Qty" />
															{
																addServiceToTokenLoad ? (
																	<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /></span></Button>
																) : (
																	<Button className="btn-t1" id="add_item" type="submit">Add Item</Button>
																)
															}
														</Form>
													</Col>
												</Row>
											) : (
												user.permission !== undefined ? (
													user.permission.token_service !== undefined ? (
														user.permission.token_service.A ? (
															<Row className="mb-2" >
																<Col className="service-search-wrapper mx-2 p-2" >
																	<Form className="service-add-form" onSubmit={serviceAdd} >
																		<div className="pos-rel">
																			<Form.Control type="text" id="serv_search" onChange={(e) => { serviceSearch(e.target.value) }} autoComplete="off" placeholder="Add new service" />
																			{
																				serviceSearchResult !== undefined && showAutoSuggestion ? (
																					Object.keys(serviceSearchResult).length > 0 ? (
																						<div className="customer-search-results bdr1">
																							{
																								Object.keys(serviceSearchResult).map((serv, serv_i) => (
																									<span onClick={() => {
																										setSelectedServiceItem({ id: serv, service: serviceSearchResult[serv] });
																										setShowAutoSuggestion(false);
																									}} className={serv === Object.keys(serviceSearchResult)[serviceSelectCount] ? 'd-grid bdrb1 active' : 'd-grid bdrb1'} key={`servi_${serv_i}`}>{serviceSearchResult[serv].name}</span>
																								))
																							}
																						</div>
																					) : ''
																				) : ''
																			}
																		</div>
																		<Form.Control type="number" name="qty" id="service_qty" defaultValue="1" min="1" placeholder="Qty" />
																		{
																			addServiceToTokenLoad ? (
																				<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /></span></Button>
																			) : (
																				<Button className="btn-t1" id="add_item" type="submit">Add Item</Button>
																			)
																		}
																	</Form>
																</Col>
															</Row>
														) : ''
													) : ''
												) : ''
											)
										) : ''
									}
									<Row>
										<Col className="p-2" >
											<Table bordered className="tbl-bill tbl-bg-blue" >
												<thead>
													<tr>
														<th>Index</th>
														<th>Services</th>
														<th className="text-end" >SC</th>
														<th className="text-end" >TC</th>
														<th className="text-end" >Price</th>
														<th className="text-end" >Qty</th>
														<th className="text-end" >Total</th>
													</tr>
												</thead>
												<tbody>
													{
														liveToken !== undefined ? (
															Object.keys(liveToken.details.service).length > 0 ? (
																Object.keys(liveToken.details.service).map((t_ser, ts_i) => (
																	<tr key={`bill_s_${ts_i}`} >
																		<td><span className="tp1 f16 mb-1" >{ts_i + 1}</span></td>
																		<td>
																			<Accordion>
																				<Accordion.Item eventKey="0">
																					<Accordion.Header><span className="tp1 f14" >{liveToken.details.service[t_ser].name}</span></Accordion.Header>
																					<Accordion.Body>
																						<Col>
																							<p className="ts1 f14 mb-2" >Service Charge <i className="bi bi-currency-rupee"></i>{
																								parseFloat(parseInt(liveToken.details.service[t_ser].gov_service_charge) + parseInt(liveToken.details.service[t_ser].akshaya_charge)).toFixed(2)}</p>
																							<h6>Remarks</h6>
																							<p className="p-multi-line ts1" >{liveToken.details.service[t_ser].required_doc}</p>
																						</Col>
																					</Accordion.Body>
																				</Accordion.Item>
																			</Accordion>
																		</td>
																		<td className="text-end pos-rel td-sc" >
																			{
																				ediSc !== undefined && ediSc.id === t_ser ? (
																					editScLoad ? (
																						<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
																					) : (
																						<div className="d-flex gap-1">
																							<Form onSubmit={updateSc} className="d-flex gap-1">
																								<Form.Control className="shadow-none br-2" name="sc" type="number" min="1" defaultValue={liveToken.details.service[t_ser].akshaya_charge} />
																								<Button type="submit" className="btn-t1">Ok</Button>
																							</Form>
																							<Button onClick={() => {
																								setEditSc();
																							}} className="btn-t1">Cancel</Button>
																						</div>
																					)
																				) : (
																					liveToken.details.service[t_ser].variable_charge ? (
																						<>
																							<span className="tp1 f14" >{parseFloat(liveToken.details.service[t_ser].akshaya_charge).toFixed(2)}</span>
																							<span onClick={() => { setEditSc({ id: t_ser, details: liveToken.details.service[t_ser] }) }} className="pos-abs qty-edit-icon f20 tp1"><i className="bi bi-pencil-square"></i></span>
																						</>
																					) : (
																						<span className="tp1 f14" >{parseFloat(liveToken.details.service[t_ser].akshaya_charge).toFixed(2)}</span>
																					)
																				)
																			}
																		</td>
																		<td className="text-end pos-rel td-tc" >
																			{
																				ediTc !== undefined && ediTc.id === t_ser ? (
																					editTcLoad ? (
																						<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
																					) : (
																						<div className="d-flex gap-1">
																							<Form onSubmit={updateTc} className="d-flex gap-1">
																								<Form.Control className="shadow-none br-2" name="tc" type="number" min="1" defaultValue={liveToken.details.service[t_ser].gov_service_charge} />
																								<Button type="submit" className="btn-t1">Ok</Button>
																							</Form>
																							<Button onClick={() => {
																								setEditTc();
																							}} className="btn-t1">Cancel</Button>
																						</div>
																					)
																				) : (
																					liveToken.details.service[t_ser].variable_charge ? (
																						<>
																							<span className="tp1 f14" >{parseFloat(liveToken.details.service[t_ser].gov_service_charge).toFixed(2)}</span>
																							<span onClick={() => { setEditTc({ id: t_ser, details: liveToken.details.service[t_ser] }) }} className="pos-abs qty-edit-icon f20 tp1"><i className="bi bi-pencil-square"></i></span>
																						</>
																					) : (
																						<span className="tp1 f14" >{parseFloat(liveToken.details.service[t_ser].gov_service_charge).toFixed(2)}</span>
																					)
																				)
																			}
																		</td>
																		<td className="text-end" ><span className="tp1 f14" >{
																			parseInt(liveToken.details.service[t_ser].gov_service_charge) + parseInt(liveToken.details.service[t_ser].akshaya_charge)}</span>
																		</td>
																		<td className="text-end pos-rel td-qty" >
																			{
																				editServiceItem !== undefined && serviceEdit && editServiceItem.id === t_ser ? (
																					serviceEditLoad ? (
																						<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
																					) : (
																						<div className="d-flex gap-1">
																							<Form onSubmit={updateServiceQty} className="d-flex gap-1">
																								<Form.Control className="shadow-none br-2" name="qty" type="number" min="1" defaultValue={liveToken.details.service[t_ser].quantity} />
																								<Button type="submit" className="btn-t1">Ok</Button>
																							</Form>
																							<Button onClick={() => {
																								setServiceEdit(false);
																								setEditServiceItem();
																							}} className="btn-t1">Cancel</Button>
																						</div>
																					)
																				) : (
																					<>
																						<span className="tp1 f14" >{liveToken.details.service[t_ser].quantity}</span>
																						{
																							user !== undefined ? (
																								user.type === 'admin' ? (
																									<span onClick={() => {
																										setEditServiceItem({ id: t_ser, details: liveToken.details.service[t_ser] });
																										setServiceEdit(true);
																									}} className="pos-abs qty-edit-icon f20 tp1"><i className="bi bi-pencil-square"></i></span>
																								) : (
																									user.permission !== undefined ? (
																										user.permission.token_service !== undefined ? (
																											user.permission.token_service.E ? (
																												<span onClick={() => {
																													setEditServiceItem({ id: t_ser, details: liveToken.details.service[t_ser] });
																													setServiceEdit(true);
																												}} className="pos-abs qty-edit-icon f20 tp1"><i className="bi bi-pencil-square"></i></span>
																											) : ''
																										) : ''
																									) : ''
																								)
																							) : ''
																						}
																					</>
																				)
																			}
																		</td>
																		<td className="text-end pos-rel" >
																			{
																				user !== undefined ? (
																					user.type === 'admin' ? (
																						<span onClick={() => {
																							deleteTokenService(t_ser);
																							setDeleteServiceId(t_ser);
																						}} className="pos-abs remove-service" >
																							{
																								deleteServiceId !== undefined && deleteServiceId === t_ser && serviceDeleteLoad ? (
																									<Spinner animation="border" size="sm" />
																								) : (<i className="bi bi-x-lg"></i>)
																							}
																						</span>
																					) : (
																						user.permission !== undefined ? (
																							user.permission.token_service !== undefined ? (
																								user.permission.token_service.D ? (
																									<span onClick={() => {
																										deleteTokenService(t_ser);
																										setDeleteServiceId(t_ser);
																									}} className="pos-abs remove-service" >
																										{
																											deleteServiceId !== undefined && deleteServiceId === t_ser && serviceDeleteLoad ? (
																												<Spinner animation="border" size="sm" />
																											) : (
																												<i className="bi bi-x-lg"></i>
																											)
																										}
																									</span>
																								) : ''
																							) : ''
																						) : ''
																					)
																				) : ''
																			}
																			<span className="tp1 f18" >{(parseInt(liveToken.details.service[t_ser].gov_service_charge) + parseInt(liveToken.details.service[t_ser].akshaya_charge)) * parseInt(liveToken.details.service[t_ser].quantity)}</span>
																		</td>
																	</tr>
																))
															) : ''
														) : ''
													}
													<tr>
														<td colSpan={4} ></td>
														<td colSpan={2} className="text-end bgy" ><span className="tp1 f18" >Total</span></td>
														<td className="text-end bgy" >{subTotal !== undefined ? subTotal : '--'}</td>
													</tr>
												</tbody>
											</Table>
										</Col>
									</Row>
								</>
							) : manageTokenState === 'cancel_token' ? (
								<Form onSubmit={cancelToken} >
									<Form.Group className="mb-3" >
										<Form.Label>Reason for cancellation {reasonREqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
										<Form.Control as="textarea" className="shadow-none br-2" name="reason" />
									</Form.Group>
									<div className="d-grid">
										{
											cancelTokenLoad ? (
												<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /></span></Button>
											) : (
												<Button type="submit" className="btn-t1">Confirm Cancel</Button>
											)
										}
									</div>
								</Form>
							) : manageTokenState === 'reccurent_service' ? (
								recService !== undefined ? (
									Object.keys(recService).length > 0 ? (
										<>
											<span className="tp1 f18 mb-1 py-2 px-4 bgs1 bdr2 d-grid br-3 mb-3" >Recurrent Service remaining customers details</span>
											{
												Object.keys(recService).map((recS, recS_i) => (
													<Row className="bdr1 p-2 m-1 mb-3 br-2" key={`recs_${recS_i}`}>
														<Col xs={12} sm={12} md={12} lg={12} >
															<span className="f20 tp2 py-2 d-grid" >{recService[recS].name}{recService[recS].quantity > 1 ? (<> ( {recService[recS].quantity} )</>) : ''}</span>
															<Form >
																<Row>
																	<Col xs={12} sm={12} md={4} lg={4} className="mb-3" >
																		<Form.Group >
																			<Form.Label className="f16 ts2" >Contact number</Form.Label>
																			<div className="serach-customer d-grid pos-rel">
																				<Form.Control defaultValue={recService[recS].notify.phone !== undefined ? recService[recS].notify.phone : ''}
																					onBlur={() => {
																						setTimeout(() => {
																							setRecAutoSuggest(false);
																							setCusSelectCount(-1);
																						}, 200);
																					}}
																					onChange={(e) => {
																						changeNotify(e.target.value, recS, "phone")
																					}} autoComplete="off" onWheel={(e) => { e.target.blur() }} name="phone" id={`phone${recS}`} type="number" min="1" className="shadow-none br-2 cus_phone" />
																				{
																					customerSearchResult !== undefined && recAutoSuggest && nRecId === recS ? (
																						Object.keys(customerSearchResult).length > 0 ? (
																							<div className="customer-search-results bdr1">
																								{
																									Object.keys(customerSearchResult).map((cus, cus_index) => (
																										<span onClick={() => {
																											$(`#phone${recS}`).val(tokenCustomers[cus].phone);
																											$(`#name${recS}`).val(tokenCustomers[cus].name);
																											$(`#address${recS}`).val(tokenCustomers[cus].address);
																											setRecService(prev => ({
																												...prev, [recS]: {
																													...prev[recS], notify: {
																														...prev[recS].notify, customer_id: cus.substring(1),
																													}
																												}
																											}
																											));
																											setRecService(prev => ({
																												...prev, [recS]: {
																													...prev[recS], notify: {
																														...prev[recS].notify, phone: tokenCustomers[cus].phone,
																													}
																												}
																											}
																											));
																											setRecService(prev => ({
																												...prev, [recS]: {
																													...prev[recS], notify: {
																														...prev[recS].notify, name: tokenCustomers[cus].name,
																													}
																												}
																											}
																											));
																											setRecService(prev => ({
																												...prev, [recS]: {
																													...prev[recS], notify: {
																														...prev[recS].notify, address: tokenCustomers[cus].address,
																													}
																												}
																											}
																											));
																										}} className={cus === Object.keys(customerSearchResult)[cusSelectCount] ? 'd-grid bdrb1 active' : 'd-grid bdrb1'} key={`cust_${cus_index}`}>{customerSearchResult[cus].name} - {customerSearchResult[cus].phone} </span>
																									))
																								}
																							</div>
																						) : ''
																					) : ''
																				}
																			</div>
																		</Form.Group>
																	</Col>
																	<Col xs={12} sm={12} md={4} lg={4} className="mb-3">
																		<Form.Group>
																			<Form.Label className="f16 ts2" >Name</Form.Label>
																			<Form.Control defaultValue={recService[recS].notify.name !== undefined ? recService[recS].notify.name : ''} onChange={(e) => { changeNotify(e.target.value, recS, "name") }} name="name" id={`name${recS}`} type="text" className="shadow-none br-2" />
																		</Form.Group>
																	</Col>
																	<Col xs={12} sm={12} md={4} lg={4} className="mb-3">
																		<Form.Group>
																			<Form.Label className="f16 ts2" >Expiry date</Form.Label>
																			{
																				recService[recS].variable_expiry_period ? (
																					<Form.Control onChange={(e) => { changeNotify(e.target.value, recS, "expiry_date") }} defaultValue={recService[recS].notify.expiry_date !== undefined ? recService[recS].notify.expiry_date : ''} name="expiry" type="date" className="shadow-none br-2" />
																				) : (
																					<Form.Control defaultValue={recService[recS].notify.expiry_date !== undefined ? recService[recS].notify.expiry_date : ''} disabled name="expiry" type="date" className="shadow-none br-2" />
																				)
																			}
																		</Form.Group>
																	</Col>
																</Row>
																<Row>
																	<Col xs={12} sm={12} md={6} lg={6} className="mb-3">
																		<Form.Group>
																			<Form.Label className="f16 ts2" >Address</Form.Label>
																			<Form.Control defaultValue={recService[recS].notify.address !== undefined ? recService[recS].notify.address : ''} onChange={(e) => { changeNotify(e.target.value, recS, "address") }} name="address" id={`address${recS}`} as="textarea" className="shadow-none br-2" />
																		</Form.Group>
																	</Col>
																	<Col xs={12} sm={12} md={6} lg={6} className="mb-3">
																		<Form.Group>
																			<Form.Label className="f16 ts2" >Other Contact details</Form.Label>
																			<Form.Control defaultValue={recService[recS].notify.other_detail !== undefined ? recService[recS].notify.other_detail : ''} onChange={(e) => { changeNotify(e.target.value, recS, "other_detail") }} name="other_details" as="textarea" className="shadow-none br-2" />
																		</Form.Group>
																	</Col>
																</Row>
															</Form>
														</Col>
													</Row>
												))
											}
										</>
									) : ''
								) : ''
							) : manageTokenState === 'payment_token' ? (
								<>
									<span className="d-grid f18 tp2 mb-3" >Total bill amount : {subTotal !== undefined ? subTotal : '--'}</span>
									{
										getWbLoad ? (
											<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Checking wallet please wait...</span>
										) : (
											wallBalance !== undefined ? (
												<span className="d-grid f18 tp2 mb-3" >Cash available in wallet = {wallBalance}</span>
											) : (<span className="d-grid f18 tp2 mb-3" >Wallet NOT found!</span>)
										)
									}
									<Row>
										{
											payModes !== undefined ? (
												Object.keys(payModes).length > 0 ? (
													Object.keys(payModes).map((payMode, payMode_i) => (
														payModes[payMode].cw ? (
															wallBalance !== undefined ? (
																<Col xs={12} sm={6} md={3} lg={3} key={`pay_${payMode_i}`}>
																	<InputGroup className="mb-3 br-2">
																		<InputGroup.Text >{payModes[payMode].name}</InputGroup.Text>
																		<Form.Control onChange={(e) => {
																			addBillAmount(e.target.value, payMode);
																			setWalletEntry(e.target.value);
																		}} name="coin" type="number" min="1" />
																	</InputGroup>
																</Col>
															) : ''
														) : (
															<Col xs={12} sm={6} md={3} lg={3} key={`pay_${payMode_i}`}>
																<InputGroup className="mb-3 br-2">
																	<InputGroup.Text >{payModes[payMode].name}</InputGroup.Text>
																	<Form.Control onChange={(e) => { addBillAmount(e.target.value, payMode) }} name="coin" type="number" min="1" />
																</InputGroup>
															</Col>
														)
													))
												) : ''
											) : ''
										}
									</Row>
								</>
							) : manageTokenState === 'print' ? (
								<div id="bill_print" className='pt-2 mx-2 p-2' ref={billRef}>
									{
										account !== undefined ? (
											<div className="d-grid align-items-center justify-content-center text-center" >
												{
													account.logo !== "" ? (
														<div className="d-grid text-center justify-content-center">
															<img src={account.logo} style={{ maxWidth: '100px', maxHeight: '100px' }} />
														</div>
													) : ''
												}
												{
													account.name !== "" || account.address !== "" || account.phone_numbers ? (
														<div className="d-grid text-center">
															<span className="f20"><b>{account.name}</b></span>
															<span className="f14" >{account.address}</span>
															<span className="f14" >{account.phone_numbers}</span>
														</div>
													) : ''
												}
											</div>
										) : ''
									}
									{
										liveToken !== undefined ? (
											<div className="grid1by1 br-2 align-items-center justify-content-between mb-2" >
												<div className='d-grid' >
													<span className="f14">Customer details</span>
													<span className="f14">{liveToken.details.customer_name}</span>
													<span className="f14">{liveToken.details.phone}</span>
												</div>
												<div className="d-grid align-items-center justify-content-end text-end">
													<span className="f14">Invoice details</span>
													<span className="f14">{liveToken.details.bill_id} : Invoice number</span>
													<span className="f14">{liveToken.details.date} / {liveToken.details.time} : Date</span>
												</div>
											</div>
										) : ''
									}
									<Table className="tbl-bill-print" bordered>
										<thead>
											<tr className="" >
												<th className="" >No</th>
												<th className="" >Services</th>
												<th className="text-end" >Price</th>
												<th className="text-end" >Qty</th>
												<th className="text-end" >Total</th>
											</tr>
										</thead>
										<tbody>
											{
												liveToken !== undefined ? (
													Object.keys(liveToken.details.service).length > 0 ? (
														Object.keys(liveToken.details.service).map((t_ser, ts_i) => (
															<tr key={`bill_s_${ts_i}`} className="" >
																<td className=""><span className="f14" >{ts_i + 1}</span></td>
																<td className=""><span className="f14" >{liveToken.details.service[t_ser].name}</span></td>
																<td className="text-end" ><span className="f14" >{
																	parseFloat(parseInt(liveToken.details.service[t_ser].gov_service_charge) + parseInt(liveToken.details.service[t_ser].akshaya_charge)).toFixed(2)}</span></td>
																<td className="text-end"><span className="f14" >{liveToken.details.service[t_ser].quantity}</span></td>
																<td className="text-end" >
																	<span className="f14" >{parseFloat((parseFloat(liveToken.details.service[t_ser].gov_service_charge) + parseFloat(liveToken.details.service[t_ser].akshaya_charge)) * parseInt(liveToken.details.service[t_ser].quantity)).toFixed(2)}</span>
																</td>
															</tr>
														))
													) : ''
												) : ''
											}
											<tr className="" >
												<td colSpan={4} className="text-end" ><span className="f18" >Total</span></td>
												<td className="text-end" ><span className="f18" >{subTotal !== undefined ? parseFloat(subTotal).toFixed(2) : '--'}</span></td>
											</tr>
										</tbody>
									</Table>
									<div className="d-grid bill-signature px-3 pt-2 pb-5">
										<span className="f14" >System generated invoice. by {user !== undefined ? user.profile.first_name : ''}</span>
									</div>
								</div>
							) : ''
						) : ''
					}
				</Modal.Body>
				<Modal.Footer>
					{
						manageTokenState !== undefined ? (
							manageTokenState === 'add_service' ? (
								user !== undefined && liveToken !== undefined ? (
									user.profile.user_id === liveToken.details.user_id ? (
										<>
											{
												editToken !== undefined && editToken ? '' : (
													<Button onClick={() => { setManageTokenState('cancel_token') }} className="btn-t1" ><i className="bi bi-x-circle"></i> Cancel</Button>
												)
											}
											<Button onClick={() => { setManageTokenState('print') }} className="btn-t1" ><i className="bi bi-receipt"></i> Bill</Button>
											<Button onClick={() => {
												addServiceNext();
												// setManageTokenState('pay-w');
											}} className="btn-t1" >Next <i className="bi bi-arrow-right-circle"></i></Button>
										</>
									) : ''
								) : ''
							) : manageTokenState === 'pay-w' ? (
								<>
									<Button onClick={() => { setManageTokenState('add_service') }} className="btn-t1" ><i className="bi bi-arrow-left-circle"></i> Back</Button>
									{
										user !== undefined ? (
											user.type === 'admin' ? (
												<Button onClick={() => { checkReccurent() }} className="btn-t1" >Next <i className="bi bi-arrow-right-circle"></i></Button>
											) : (
												user.permission !== undefined ? (
													user.permission.token !== undefined ? (
														user.permission.token.E ? (
															<Button onClick={() => { checkReccurent() }} className="btn-t1" >Next <i className="bi bi-arrow-right-circle"></i></Button>
														) : (
															recStatus !== undefined && recStatus ? (
																<Button onClick={() => { checkReccurent() }} className="btn-t1" >Next <i className="bi bi-arrow-right-circle"></i></Button>
															) : (
																submitTokenLoad ? (
																	<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
																) : (
																	<Button onClick={() => { submitToken() }} className="btn-t1" >Submit</Button>
																)
															)
														)
													) : ''
												) : ''
											)
										) : ''
									}
								</>
							) : manageTokenState === 'cancel_token' ? (
								<Button onClick={() => { setManageTokenState('add_service') }} className="btn-t1" ><i className="bi bi-arrow-left-circle"></i> Back</Button>
							) : manageTokenState === 'reccurent_service' ? (
								<>
									<Button onClick={() => { backReccurent() }} className="btn-t1" ><i className="bi bi-arrow-left-circle"></i> Back</Button>
									{
										user !== undefined ? (
											user.type === 'admin' ? (
												<Button onClick={() => { setManageTokenState('payment_token') }} className="btn-t1" >Next <i className="bi bi-arrow-right-circle"></i></Button>
											) : (
												user.permission !== undefined ? (
													user.permission.token !== undefined ? (
														user.permission.token.E ? (
															<Button onClick={() => { setManageTokenState('payment_token') }} className="btn-t1" >Next <i className="bi bi-arrow-right-circle"></i></Button>
														) : (
															submitTokenLoad ? (
																<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
															) : (
																<Button onClick={() => { submitToken() }} className="btn-t1" >Submit</Button>
															)
														)
													) : ''
												) : ''
											)
										) : ''
									}
								</>
							) : manageTokenState === 'payment_token' ? (
								<>
									<Button className="btn-t1" onClick={() => {
										backPayment();
										setBillAmount({});
										setTotalCashEntry();
									}} ><i className="bi bi-arrow-left-circle"></i> Back</Button>
									{
										billSettleLoad ? (
											<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
										) : (
											subTotal !== undefined && totalCashEntry !== undefined && subTotal === totalCashEntry ? (
												<>
													<Button onClick={() => {
														if (wallBalance !== undefined && walletEntry !== undefined) {
															if (walletEntry <= wallBalance) {
																settleBill(true);
																setManageTokenState('print');
															} else {
																$.alert({
																	title: 'Something went wrong',
																	content: 'Wallet amount is greater than the balance available!',
																	type: 'red',
																});
															}
														} else {
															settleBill(true);
															setManageTokenState('print');
														}
													}} className="btn-t1" ><i className="bi bi-printer"></i> Print & Settle</Button>
													<Button onClick={() => {
														if (wallBalance !== undefined && walletEntry !== undefined) {
															if (walletEntry <= wallBalance) {
																settleBill(false);
															} else {
																$.alert({
																	title: 'Something went wrong',
																	content: 'Wallet amount is greater than the balance available!',
																	type: 'red',
																});
															}
														} else {
															settleBill(false);
														}
													}} className="btn-t1" >Settle</Button>
												</>
											) : (
												<>
													<Button className="btn-t1" disabled><i className="bi bi-printer"></i> Print & Settle</Button>
													<Button className="btn-t1" disabled>Settle</Button>
												</>
											)
										)
									}
								</>
							) : manageTokenState === 'print' ? (
								<ReactToPrint
									trigger={() => <Button className="btn-t1" ><i className="bi bi-printer"></i> Print</Button>}
									content={() => billRef.current}
								/>
							) : ''
						) : ''
					}
				</Modal.Footer>
			</Modal>
			<Modal size="xl" show={newTokenModel} backdrop="static" onHide={() => { setNewTokenModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>
						<div className="d-grid">
							{
								tokenBookingState !== undefined ? (
									tokenBookingState === 'start' ? (
										tokenAddSuccess ? (
											<span className="tp1 mb-1 sucess-alert" >Success!</span>
										) : (
											<span className="tp1 f18 mb-1" >Available services</span>
										)
									) : tokenBookingState === 'token' ? (
										selectedService !== undefined ? (
											<span className="tp1 f18" >{selectedService.details.name}</span>
										) : ''
									) : ''
								) : ''
							}
						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{
						tokenBookingState !== undefined ? (
							tokenBookingState === 'start' ? (
								<Row>
									<Col xs={12} sm={12} md={12} lg={12} className="service-search mb-3" >
										<Form onSubmit={(e) => { e.preventDefault() }} >
											<InputGroup>
												<Form.Control onChange={(e) => { searchServices(e.target.value) }} className="br-2" size="lg" type="text" placeholder="Search here" />
												<InputGroup.Text className="br-3 btn-t1 px-4" id="basic-addon2"><i className="bi bi-search"></i></InputGroup.Text>
											</InputGroup>
										</Form>
									</Col>
									{
										tokenServices !== undefined ? (
											Object.keys(tokenServices).length > 0 ? (
												serviceSearchResults !== undefined ? (
													Object.keys(serviceSearchResults).length > 0 ? (
														Object.keys(serviceSearchResults).map((t_serice, ts_i) => (
															<Col xs={12} sm={12} md={12} lg={12} className="mb-3" key={`t_serice_${ts_i}`} >
																<div className="d-flex justify-content-between align-items-center br-3" >
																	<Accordion flush>
																		<Accordion.Item eventKey="0">
																			<Accordion.Header><span className="tp1 f18" >{tokenServices[t_serice].name}</span></Accordion.Header>
																			<Accordion.Body>
																				<Col>
																					<p className="ts1 f16 mb-2" >Service Charge <i className="bi bi-currency-rupee"></i>{
																						parseInt(tokenServices[t_serice].gov_service_charge) + parseInt(tokenServices[t_serice].akshaya_charge)}</p>
																					<h5 className="ts1" >Required documents</h5>
																					<p className="p-multi-line ts1" >{tokenServices[t_serice].required_doc}</p>
																				</Col>
																			</Accordion.Body>
																		</Accordion.Item>
																	</Accordion>
																	<Button className="btn-t1" onClick={() => {
																		setTokenBookingState('token');
																		setSelectedService({ id: t_serice, details: tokenServices[t_serice] });
																	}} ><i className="bi bi-plus-lg"></i></Button>
																</div>
															</Col>
														))
													) : <div className="d-grid text-center p-3 text-muted">No services found!</div>
												) : (
													Object.keys(tokenServices).map((t_serice, ts_i) => (
														<Col xs={12} sm={12} md={12} lg={12} className="mb-3" key={`t_serice_${ts_i}`} >
															<div className="d-flex justify-content-between align-items-center br-3" >
																<Accordion flush>
																	<Accordion.Item eventKey="0">
																		<Accordion.Header><span className="tp1 f18" >{tokenServices[t_serice].name}</span></Accordion.Header>
																		<Accordion.Body>
																			<Col>
																				<p className="ts1 f16 mb-2" >Service Charge <i className="bi bi-currency-rupee"></i>{
																					parseInt(tokenServices[t_serice].gov_service_charge) + parseInt(tokenServices[t_serice].akshaya_charge)}</p>
																				<h5 className="ts1" >Required documents</h5>
																				<p className="p-multi-line ts1" >{tokenServices[t_serice].required_doc}</p>
																			</Col>
																		</Accordion.Body>
																	</Accordion.Item>
																</Accordion>
																<Button className="btn-t1" onClick={() => {
																	setTokenBookingState('token');
																	setSelectedService({ id: t_serice, details: tokenServices[t_serice] });
																}} ><i className="bi bi-plus-lg"></i></Button>
															</div>
														</Col>
													))
												)
											) : 'Services not found'
										) : 'Permission denied'
									}
								</Row>
							) : tokenBookingState === 'token' ? (
								<Row>
									<Col>
										<Form onSubmit={generateToken}>
											<Form.Group className="mb-3">
												<Form.Label>Quantity {qtyReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
												<Form.Control type="number" name="qty" min="1" className="shadow-none br-2" placeholder="Number of service" defaultValue="1" />
											</Form.Group>
											<Row>
												<Col xs={12} sm={12} md={12} lg={6} >
													<Form.Group className="mb-3">
														<Form.Label>Contact number {phoneReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
														<div className="serach-customer d-grid pos-rel">
															<Form.Control onBlur={() => {
																setTimeout(() => {
																	setShowAutoSuggestionNew(false);
																}, 200);
															}} autoComplete="off" onWheel={(e) => { e.target.blur() }} id="cus_phone" onChange={(e) => { searchCustomerNew(e.target.value) }} type="number" name="phone" className="shadow-none br-2" placeholder="Contact number" />
															{
																searchResult !== undefined && showAutoSuggestionNew ? (
																	Object.keys(searchResult).length > 0 ? (
																		<div className="customer-search-results bdr1">
																			{
																				Object.keys(searchResult).map((cus, cus_index) => (
																					<span onClick={() => { setSelectedItem({ id: cus, profile: searchResult[cus] }) }} className={cus === Object.keys(searchResult)[selectCount] ? 'd-grid bdrb1 active' : 'd-grid bdrb1'} key={`cust_${cus_index}`}>{searchResult[cus].name} - {searchResult[cus].phone} </span>
																				))
																			}
																		</div>
																	) : ''
																) : ''
															}
														</div>
													</Form.Group>
												</Col>
												<Col xs={12} sm={12} md={12} lg={6} >
													<Form.Group className="mb-3">
														<Form.Label>Name {nameReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
														<Form.Control type="text" id="cus_name" name="name" className="shadow-none br-2" placeholder="Customer Name" />
													</Form.Group>
												</Col>
											</Row>
											<Row>
												<Col xs={12} sm={12} md={12} lg={6} >
													<Form.Group className="mb-3">
														<Form.Label>Address</Form.Label>
														<Form.Control as="textarea" id="cus_address" className="shadow-none br-2" name="address" />
													</Form.Group>
												</Col>
												<Col xs={12} sm={12} md={12} lg={6} >
													<Form.Group className="mb-3">
														<Form.Label>Remarks</Form.Label>
														<Form.Control as="textarea" id="cus_address" className="shadow-none br-2" name="remarks" />
													</Form.Group>
												</Col>
											</Row>
											<Form.Group className="mb-3">
												<Form.Label>Collected documents</Form.Label>
												<Form.Control as="textarea" id="cus_address" className="shadow-none br-2" name="documents" />
											</Form.Group>
											<div className="d-grid">
												{
													addTokenLoad ? (
														<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
													) : (
														<Button className="btn-t1" type="submit" >Generate Token</Button>
													)
												}
											</div>
										</Form>
									</Col>
								</Row>
							) : tokenBookingState === 'print' ? (
								<div className="d-grid align-items-center justify-content-center" ref={tokenRef}>
									{
										account !== undefined ? (
											<div className="d-grid align-items-center justify-content-center" >
												{
													account.logo !== "" ? (
														<div className="d-grid align-items-center justify-content-center" >
															<img className="px-3 py-1" src={account.logo} style={{ maxWidth: '100px', maxHeight: '100px' }} />
														</div>
													) : ''
												}
												{
													account.name !== "" || account.address !== "" || account.phone_numbers ? (
														<div className="d-grid align-items-center justify-content-center text-center">
															<span className="f20 tp0 d-grid"><b>{account.name}</b></span>
															<span className="f16 tp0 d-grid" >{account.address}</span>
															<span className="f16 tp0 d-grid" >{account.phone_numbers}</span>
														</div>
													) : ''
												}
											</div>
										) : ''
									}
									<div className="d-grid align-items-center justify-content-start" >
										<div className="print-token-detail-item py-2 bdrb1">
											<span className="f14">TOKEN NUMBER</span>
											<span className="f14">:</span>
											<span className="display-5 fw-bold">{tokenToPrint !== undefined ? tokenToPrint.details.token_number : ''}</span>
										</div>
										<div className="print-token-detail-item py-1 bdrb1">
											<span className="f14" >Service</span>
											<span className="f14">:</span>
											<span className="f14">{tokenToPrint !== undefined ? tokenToPrint.details.service[Object.keys(tokenToPrint.details.service)[0]].name : ''}</span>
										</div>
										<div className="print-token-detail-item py-1 bdrb1">
											<span className="f14">Name</span>
											<span className="f14">:</span>
											<span className="f14">{tokenToPrint !== undefined ? tokenToPrint.details.customer_name : ''}</span>
										</div>
										<div className="print-token-detail-item py-1 bdrb1">
											<span className="f14">Phone</span>
											<span className="f14">:</span>
											<span className="f14">{tokenToPrint !== undefined ? tokenToPrint.details.phone : ''}</span>
										</div>
										<div className="print-token-detail-item py-1 bdrb1">
											<span className="f14">Date</span>
											<span className="f14">:</span>
											<span className="f14">{tokenToPrint !== undefined ? tokenToPrint.details.created_date : ''}</span>
										</div>
										<div className="print-token-detail-item py-1 bdrb1">
											<span className="f14">Remarks</span>
											<span className="f16 tp0">:</span>
											<span className="f16 tp0">{tokenToPrint !== undefined ? tokenToPrint.details.remarks : ''}</span>
										</div>
									</div>
								</div>
							) : ''
						) : ''
					}
				</Modal.Body>
				<Modal.Footer>
					{
						tokenBookingState !== undefined ? (
							tokenBookingState === 'token' ? (
								<Button onClick={() => {
									setTokenBookingState('start');
									setServiceSearchResults(prev => { });
								}} className="btn-t1" ><i className="bi bi-arrow-left-circle"></i> Back</Button>
							) : tokenBookingState === 'print' ? (
								<ReactToPrint
									trigger={() => <Button id="bcode-print" className="btn-t1 br3" size="sm" ><i className="bi bi-printer"></i> Print</Button>}
									content={() => tokenRef.current}
								/>
							) : ''
						) : ''
					}
				</Modal.Footer>
			</Modal>
		</div >
	)
}
